import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import userInfo, { userInfoSync } from 'hub-http/userInfo';
const INITIAL_STATE = {
  data: undefined,
  error: undefined,
  loading: false
};
export default function useUserInfo(userInfoProps) {
  const hasUserInfoSync = useRef(false);
  const [userInfoState, setUserInfoState] = useState(() => {
    try {
      const data = userInfoSync();
      hasUserInfoSync.current = true;
      return {
        data,
        error: undefined,
        loading: false
      };
    } catch (error) {
      return INITIAL_STATE;
    }
  });
  const hasScope = useCallback(scope => Boolean(userInfoState.data && userInfoState.data.user.scopes.includes(scope)), [userInfoState.data]);
  const isUngatedFor = useCallback(gate => Boolean(userInfoState.data && userInfoState.data.gates.includes(gate)), [userInfoState.data]);
  useEffect(() => {
    if (hasUserInfoSync.current) return;
    setUserInfoState(Object.assign({}, INITIAL_STATE, {
      loading: true
    }));
    userInfo(userInfoProps).then(data => setUserInfoState(Object.assign({}, INITIAL_STATE, {
      data
    }))).catch(error => setUserInfoState(Object.assign({}, INITIAL_STATE, {
      error
    })));
  }, [userInfoProps]);
  return useMemo(() => Object.assign({}, userInfoState, {
    hasScope,
    isUngatedFor
  }), [hasScope, isUngatedFor, userInfoState]);
}